import { CampaignAdCostEntityService } from '@views/pages/apps/marketeer/campaign-ad-cost/service/campaign-ad-cost-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';


@Injectable()
export class CampaignAdCostResolver implements Resolve<boolean> {

    constructor(private campaignAdCostEntityService: CampaignAdCostEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.campaignAdCostEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.campaignAdCostEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
